import { merge } from 'lodash';
import once from 'lodash/once';
import { Container } from 'unstated';

import reduceColumns from '~/lib/revealCompaniesColumnReducer';

import { findPerson, getCachedAllPeopleColumns } from '../lib/client';

export default class PeopleContainer extends Container {
  state = {
    loading: true,
    columnsLoading: true,
    peopleLoading: true,
    segmentedPeople: {}, // keyed by segment ID
    allPeople: {}, // keyed by person Id
    allColumns: {
      clearbit: [],
    },
  };

  constructor() {
    super();

    this.fetchAllColumns();
  }

  setLoading = () => this.setState({ loading: this.anythingLoading() });

  anythingLoading = () => {
    const { columnsLoading, peopleLoading } = this.state;

    return [columnsLoading, peopleLoading].some(Boolean);
  };

  // People

  findPerson = (id) => {
    return this.state.allPeople[id];
  };

  fetchPerson = (id) => {
    this.setState({ loading: true }, () => {
      findPerson(id).then((person) => {
        const mergedPerson = merge(this.state.allPeople[id], person, {
          loaded: true,
        });
        this.setState({
          allPeople: {
            ...this.state.allPeople,
            [person.id]: mergedPerson,
          },
          loading: false,
        });
      });
    });
  };

  fetchPersonOnce = (id) => {
    this._onceFetchPerson =
      this._onceFetchPerson || once(() => this.fetchPerson(id));

    this._onceFetchPerson();
  };

  // Columns

  fetchAllColumns = () => {
    getCachedAllPeopleColumns().then(this.setAllColumns);
  };

  setAllColumns = (allColumns) => {
    this.setState(
      {
        columnsLoading: false,
        searchAttributes: reduceColumns(allColumns),
        allColumns,
      },
      this.setLoading,
    );
  };

  columnsForPicklist = () => {
    let { allColumns } = this.state;

    const flatColumns = Object.entries(allColumns).reduce(
      (columns, [category, options]) => {
        if (category === 'page_views') return columns;

        // organize sfdc columns for tabbed view
        if (/^salesforce/.test(category)) {
          const salesforceOptions = Object.entries(options).reduce(
            (salesforceColumns, [subCategory, options]) => {
              const subColumns = Object.entries(options).map(
                ([value, details]) => ({
                  value: `${category}->${subCategory}->${value}`,
                  label: details.label,
                  category,
                  subCategory,
                }),
              );
              return [...salesforceColumns, ...subColumns];
            },
            [],
          );
          return [...columns, ...salesforceOptions];
        }

        const finalOptions = Object.entries(options).map(([value, details]) => {
          let customCategory = category;
          // move page view attrs from company to 'page view' category
          if (['last_visit_at', 'last_visit_path'].includes(value)) {
            customCategory = 'page view';
          }

          return { value, label: details.label, category: customCategory };
        });

        return [...columns, ...finalOptions];
      },
      [],
    );

    return flatColumns;
  };
}
